export default "__VITE_ASSET__iMbNdKLo__"